import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiRotateCcw, FiCheckCircle, FiUserCheck } = FiIcons;

const Guarantee = () => {
  return (
    <section id="guarantee" className="py-20 bg-gradient-to-br from-blue-900/10 to-purple-900/10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-white/5 backdrop-blur-lg border border-white/20 rounded-3xl p-8 lg:p-12 relative overflow-hidden"
        >
          {/* Subtle Background Icon */}
          <div className="absolute -top-12 -right-12 opacity-5">
            <SafeIcon icon={FiShield} className="w-64 h-64 text-white" />
          </div>

          <div className="flex flex-col lg:flex-row gap-10 items-center">
            <div className="flex-shrink-0">
              <div className="w-32 h-32 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center p-6 shadow-2xl">
                <SafeIcon icon={FiShield} className="w-full h-full text-white" />
              </div>
              <div className="mt-4 text-center">
                <p className="text-blue-400 font-bold text-xs uppercase tracking-tighter">Money-Back</p>
                <p className="text-white font-bold text-sm">GUARANTEE</p>
              </div>
            </div>

            <div className="flex-grow text-center lg:text-left">
              <h2 className="text-3xl font-bold text-white mb-6">
                You Are Not Taking a Blind Risk
              </h2>
              <div className="space-y-4 text-lg text-white/80">
                <p>
                  You are never locked in to something you do not like. We build your first version based on what we agree. 
                  You review it. You can request changes.
                </p>
                <p className="font-semibold text-white">
                  If after the first revision the page is clearly not aligned with what was agreed, 
                  you can walk away and we will refund your build fee in full.
                </p>
                <p className="text-base italic opacity-60">
                  No arguments. No traps. No fine print.
                </p>
              </div>

              <div className="grid sm:grid-cols-2 gap-4 mt-8">
                {[
                  { icon: FiRotateCcw, text: "One full revision included" },
                  { icon: FiCheckCircle, text: "Preview before launch" },
                  { icon: FiUserCheck, text: "You are always in control" },
                  { icon: FiShield, text: "Refund if not aligned" }
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-sm text-white/70">
                    <SafeIcon icon={item.icon} className="text-blue-400 flex-shrink-0" />
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Guarantee;